type EmployerOverdueStatusIconProps = {
  variant?: 'card' | 'list';
};

export const EmployerOverdueStatusIcon = ({ variant = 'card' }: EmployerOverdueStatusIconProps) => {
  const isList = variant === 'list';
  return (
    <div
      className={`flex shrink-0 items-center justify-center rounded-full bg-red-100 text-red-600 dark:bg-red-900/40 dark:text-red-300 ${
        isList ? 'h-11 w-11' : 'h-10 w-10'
      }`}
      aria-hidden
    >
      <svg
        className="h-5 w-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </div>
  );
};
